import { motion } from "framer-motion";
import { CORDED, CORDLESS } from "../../lib/data";
import { Reveal, Overline, LaunchBadge, Icon } from "../ui-kit";

function ToolCard({ tool, i, cordless }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: (i % 4) * 0.06, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -8 }}
      className="group relative bg-[#0f0f10] border border-zinc-800 hover:border-orange-500/50 p-6 transition-colors overflow-hidden"
      data-testid={`product-card-${cordless ? "cordless" : "corded"}-${i}`}
    >
      <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-orange-500/0 group-hover:bg-orange-500/10 blur-2xl transition-all" />
      <div className="flex items-start justify-between">
        <div className="h-14 w-14 flex items-center justify-center bg-black border border-zinc-800 text-orange-500 group-hover:border-orange-500/50 transition-colors">
          <Icon name={tool.icon} size={26} />
        </div>
        <span className="text-[10px] font-bold uppercase tracking-widest text-zinc-600 group-hover:text-orange-500 transition-colors">
          Soon
        </span>
      </div>
      <h3 className="mt-6 font-display text-lg font-bold uppercase leading-tight text-white">{tool.name}</h3>
      {tool.spec && <p className="mt-1 text-sm text-zinc-500">{tool.spec}</p>}
      {cordless && <p className="mt-1 text-xs font-semibold uppercase tracking-wider text-zinc-600">20V Brushless</p>}
      <div className="mt-5 h-px w-full bg-zinc-800 group-hover:bg-orange-500/40 transition-colors" />
    </motion.div>
  );
}

export default function Phase1() {
  return (
    <section id="products" className="relative py-24 md:py-32 bg-[#080808] noise" data-testid="phase1-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="max-w-3xl">
          <Overline index="02">Phase 1 Launch Collection</Overline>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
            Launching <span className="text-orange-500">Soon</span>
          </h2>
          <p className="mt-5 text-lg text-zinc-400 leading-relaxed">
            Our first generation of professional power tools is designed to deliver outstanding
            performance, durability, and value for professionals across India.
          </p>
        </Reveal>

        {/* Corded */}
        <div className="mt-16 flex items-center gap-4">
          <h3 className="font-display text-xl md:text-2xl font-bold uppercase text-white">Corded Power Tools</h3>
          <LaunchBadge />
          <span className="flex-1 h-px bg-zinc-800" />
        </div>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CORDED.map((t, i) => <ToolCard key={i} tool={t} i={i} />)}
        </div>

        {/* Cordless */}
        <div className="mt-20 flex items-center gap-4">
          <h3 className="font-display text-xl md:text-2xl font-bold uppercase text-white">Cordless 20V Platform</h3>
          <LaunchBadge label="14 Tools" />
          <span className="flex-1 h-px bg-zinc-800" />
        </div>
        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {CORDLESS.map((t, i) => <ToolCard key={i} tool={t} i={i} cordless />)}
        </div>
      </div>
    </section>
  );
}
